export default __webpack_public_path__ + "static/media/deletDisable.b34b8df8.svg";